import { mande, type MandeError } from 'mande'
import type Team from '~/types/teams/team'

export default function useTeamsApi() {
  const config = useRuntimeConfig()
  const api = () => {
    return mande(config.public.apiUrl + '/teams', {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      credentials: 'include',
    })
  }

  const create = async (name: string) => {
    try {
      return await api().post<Team>({ name })
    } catch (error) {
      throw useHttpError(error as MandeError)
    }
  }

  const get = async (id: string) => {
    try {
      return await api().get<Team>(`/${id}`)
    } catch (error) {
      throw useHttpError(error as MandeError)
    }
  }

  const getAll = async () => {
    try {
      return await api().get<Team[]>()
    } catch (error) {
      throw useHttpError(error as MandeError)
    }
  }

  return {
    create,
    get,
    getAll,
  }
}
